"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.MANUAL_LOCATION_LINK = exports.LOCATION_SELECTOR__ROOT = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    LOCATION_SELECTOR__ROOT = (0, _cxs["default"])({
  width: "100%"
});

exports.LOCATION_SELECTOR__ROOT = LOCATION_SELECTOR__ROOT;
var MANUAL_LOCATION_LINK = (0, _cxs["default"])({
  " .text--link": {
    fontSize: "12px"
  }
});
exports.MANUAL_LOCATION_LINK = MANUAL_LOCATION_LINK;